/**
 * SECTION 5C JS
 *
 * DATA TO BE STORED IN THE BACKEND FOR THIS:
 * - 
 *
 */
import $ from 'jquery';
import aon_craft_utils from './aon_craft_utils.js';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise Section 5C, data
         * UI interaction functions etc
         */
        console.log( 'Section 5C - init' );
        
        //var where_do_you_take_inspiration = '';
        
        // 5C Data
        this.aon_section_5c_data = [];
        
        this.badges_earned_array = [];
        
        // Get any existing saved data...
        if ( $( '#business_plan' ).length > 0 ) { // If Business Plan page then load live data...
            this.loadData( 'load_live' );
            
        } else { // If not Business Plan page then we are in 1A...
            if ( $( '#section_5c_data_json' ).val() != '' ) { // If JSON data field is not empty then we presume this is saved data and try to load it...
                this.loadData( 'load_live' );
                
            } else { // If no saved data then we start with a default data structure...
                this.loadData( 'start' ); 
            }
            //this.loadData( 'load_demo' );
        }
        
        // Render Data...
        this.renderData();
                
        
        // SUSTAINABILITY MAP MODALS...
        $( 'body' ).on( 'click', '#sustainability_map_modal_1 .button', ( event ) => {
            $( '#sustainability_map_modal_1' ).addClass( 'hide' );
            $( '#sustainability_map_modal_2' ).removeClass( 'hide' );
            $( '#sustainability_map_modal_3' ).addClass( 'hide' );
            $( '#sustainability_map_modal_4' ).addClass( 'hide' );
            $( '#sustainability_map_modal_5' ).addClass( 'hide' );
            $( '#sustainability_map_modal_6' ).addClass( 'hide' );
            // Hide Single-tree map...
            $( '#sustainability_map_single_tree' ).addClass( 'hide' );
            // Show main map...
            $( '#sustainability_map_static' ).removeClass( 'hide' );
            // Scroll to next point...
            Foundation.SmoothScroll.scrollToLoc( '#sustainability_map_static #map_scroll_1' );
            //
            event.preventDefault();
        });
        $( 'body' ).on( 'click', '#sustainability_map_modal_2 .button', ( event ) => {
            $( '#sustainability_map_modal_1' ).addClass( 'hide' );
            $( '#sustainability_map_modal_2' ).addClass( 'hide' );
            $( '#sustainability_map_modal_3' ).removeClass( 'hide' );
            $( '#sustainability_map_modal_4' ).addClass( 'hide' );
            $( '#sustainability_map_modal_5' ).addClass( 'hide' );
            $( '#sustainability_map_modal_6' ).addClass( 'hide' );
            // Adjust Progress map item visibility...
            $( '#sustainability_map_static' ).removeClass( 'step-2' ).addClass( 'step-3' );
            // Scroll to next point...
            Foundation.SmoothScroll.scrollToLoc( '#sustainability_map_static #map_scroll_2' );
            //
            event.preventDefault();
        });
        $( 'body' ).on( 'click', '#sustainability_map_modal_3 .button', ( event ) => {
            $( '#sustainability_map_modal_1' ).addClass( 'hide' );
            $( '#sustainability_map_modal_2' ).addClass( 'hide' );
            $( '#sustainability_map_modal_3' ).addClass( 'hide' );
            $( '#sustainability_map_modal_4' ).removeClass( 'hide' );
            $( '#sustainability_map_modal_5' ).addClass( 'hide' );
            $( '#sustainability_map_modal_6' ).addClass( 'hide' );
            // Adjust Progress map item visibility...
            $( '#sustainability_map_static' ).removeClass( 'step-3' ).addClass( 'step-4' );
            // Scroll to next point...
            Foundation.SmoothScroll.scrollToLoc( '#sustainability_map_static #map_scroll_3' );
            //
            event.preventDefault();
        });
        $( 'body' ).on( 'click', '#sustainability_map_modal_4 .button', ( event ) => {
            $( '#sustainability_map_modal_1' ).addClass( 'hide' );
            $( '#sustainability_map_modal_2' ).addClass( 'hide' );
            $( '#sustainability_map_modal_3' ).addClass( 'hide' );
            $( '#sustainability_map_modal_4' ).addClass( 'hide' );
            $( '#sustainability_map_modal_5' ).removeClass( 'hide' );
            $( '#sustainability_map_modal_6' ).addClass( 'hide' );
            // Adjust Progress map item visibility...
            $( '#sustainability_map_static' ).removeClass( 'step-4' ).addClass( 'step-5' );
            // Scroll to next point...
            Foundation.SmoothScroll.scrollToLoc( '#sustainability_map_static #map_scroll_4' );
            //
            event.preventDefault();
        });
        $( 'body' ).on( 'click', '#sustainability_map_modal_5 .button', ( event ) => {
            $( '#sustainability_map_modal_1' ).addClass( 'hide' );
            $( '#sustainability_map_modal_2' ).addClass( 'hide' );
            $( '#sustainability_map_modal_3' ).addClass( 'hide' );
            $( '#sustainability_map_modal_4' ).addClass( 'hide' );
            $( '#sustainability_map_modal_5' ).addClass( 'hide' );
            $( '#sustainability_map_modal_6' ).removeClass( 'hide' );
            // Adjust Progress map item visibility...
            $( '#sustainability_map_static' ).removeClass( 'step-5' ).addClass( 'step-6' );
            // Scroll to next point...
            Foundation.SmoothScroll.scrollToLoc( '#sustainability_map_static #map_scroll_5' );
            //
            event.preventDefault();
        });
        $( 'body' ).on( 'click', '#sustainability_map_modal_6 .button', ( event ) => {
            $( '#sustainability_map_modal_1' ).addClass( 'hide' );
            $( '#sustainability_map_modal_2' ).addClass( 'hide' );
            $( '#sustainability_map_modal_3' ).addClass( 'hide' );
            $( '#sustainability_map_modal_4' ).addClass( 'hide' );
            $( '#sustainability_map_modal_5' ).addClass( 'hide' );
            $( '#sustainability_map_modal_6' ).addClass( 'hide' );
            // Adjust Progress map item visibility...
            // Show zoom controls
            $( '.zoom-controls-container' ).removeClass( 'hide' );
            $( '.zoom-controls-text-row' ).removeClass( 'bottom-padding-two' );
            // Scroll to next point...
            Foundation.SmoothScroll.scrollToLoc( '#sustainability_map_static_zoom_controls' );
            
            // Make map draggable
            $( '#sustainability_map_static' ).removeClass( 'disabled' );
            setDragItemAndContainer( 'sustainability_map_static' );
            //
            // Enabled next button...
            $( '.map_intro' ).removeClass( 'disabled' );
            event.preventDefault();
        });
        
        
        
        // Key up on Sustainability Map Questions...
        $( 'body' ).on( 'keyup change', '.key_block textarea', function( event ) {
            var id = $( this ).attr( 'id' );
            event.preventDefault();
        });
        
        var callCheckEarnedBadges = () => {
            this.checkEarnedBadges();
        }
        
        // Click on Sustainability Map Questions Next buttons...
        $( 'body' ).on( 'click', '.smq_next', function( event ) {
            //var class = $( this ).attr( 'id' );
            if ( $( this ).hasClass( 'questions_designing_next' ) ) {
                saveSMQEntry( 'designing_q_one', aon_craft_utils.removeHTMLTags( $( '.key_block #designing_q_one' ).val() ) );
                saveSMQEntry( 'designing_q_two', aon_craft_utils.removeHTMLTags( $( '.key_block #designing_q_two' ).val() ) );
                
                $( '.designing .positive-impact p' ).text( $( '.key_block #designing_q_one' ).val() );
                $( '.designing .challenges-faced p' ).text( $( '.key_block #designing_q_two' ).val() );
                
            } else if ( $( this ).hasClass( 'questions_developing_next' ) ) {
                saveSMQEntry( 'developing_q_one', aon_craft_utils.removeHTMLTags( $( '.key_block #developing_q_one' ).val() ) );
                saveSMQEntry( 'developing_q_two', aon_craft_utils.removeHTMLTags( $( '.key_block #developing_q_two' ).val() ) );
                
                $( '.developing .positive-impact p' ).text( $( '.key_block #developing_q_one' ).val() );
                $( '.developing .challenges-faced p' ).text( $( '.key_block #developing_q_two' ).val() );
                
            } else if ( $( this ).hasClass( 'questions_sourcing_next' ) ) {
                saveSMQEntry( 'sourcing_q_one', aon_craft_utils.removeHTMLTags( $( '.key_block #sourcing_q_one' ).val() ) );
                saveSMQEntry( 'sourcing_q_two', aon_craft_utils.removeHTMLTags( $( '.key_block #sourcing_q_two' ).val() ) );
                saveSMQEntry( 'sourcing_q_three', aon_craft_utils.removeHTMLTags( $( '.key_block #sourcing_q_three' ).val() ) );
                saveSMQEntry( 'sourcing_q_four', aon_craft_utils.removeHTMLTags( $( '.key_block #sourcing_q_four' ).val() ) );
                
                $( '.sourcing-materials .positive-impact p' ).html( $( '.key_block #sourcing_q_one' ).val() + '.<br>' + $( '.key_block #sourcing_q_two' ).val() + '.<br>' + $( '.key_block #sourcing_q_three' ).val() );
                $( '.sourcing-materials .challenges-faced p' ).text( $( '.key_block #sourcing_q_four' ).val() );
                
            } else if ( $( this ).hasClass( 'questions_transforming_next' ) ) {
                saveSMQEntry( 'transforming_q_one', aon_craft_utils.removeHTMLTags( $( '.key_block #transforming_q_one' ).val() ) );
                saveSMQEntry( 'transforming_q_two', aon_craft_utils.removeHTMLTags( $( '.key_block #transforming_q_two' ).val() ) );
                
                $( '.transforming-materials .positive-impact p' ).text( $( '.key_block #transforming_q_one' ).val() );
                $( '.transforming-materials .challenges-faced p' ).text( $( '.key_block #transforming_q_two' ).val() );
                
            } else if ( $( this ).hasClass( 'questions_packaging_next' ) ) {
                saveSMQEntry( 'packaging_q_one', aon_craft_utils.removeHTMLTags( $( '.key_block #packaging_q_one' ).val() ) );
                saveSMQEntry( 'packaging_q_two', aon_craft_utils.removeHTMLTags( $( '.key_block #packaging_q_two' ).val() ) );
                
                $( '.packaging .positive-impact p' ).text( $( '.key_block #packaging_q_one' ).val() );
                $( '.packaging .challenges-faced p' ).text( $( '.key_block #packaging_q_two' ).val() );
                
            } else if ( $( this ).hasClass( 'questions_distribution_next' ) ) {
                saveSMQEntry( 'distribution_q_one', aon_craft_utils.removeHTMLTags( $( '.key_block #distribution_q_one' ).val() ) );
                saveSMQEntry( 'distribution_q_two', aon_craft_utils.removeHTMLTags( $( '.key_block #distribution_q_two' ).val() ) );
                saveSMQEntry( 'distribution_q_three', aon_craft_utils.removeHTMLTags( $( '.key_block #distribution_q_three' ).val() ) );
                
                $( '.distribution .positive-impact p' ).html( $( '.key_block #distribution_q_one' ).val() + '.<br>' + $( '.key_block #distribution_q_two' ).val() );
                $( '.distribution .challenges-faced p' ).text( $( '.key_block #distribution_q_three' ).val() );
                
            } else if ( $( this ).hasClass( 'questions_marketing_next' ) ) {
                saveSMQEntry( 'marketing_q_one', aon_craft_utils.removeHTMLTags( $( '.key_block #marketing_q_one' ).val() ) );
                saveSMQEntry( 'marketing_q_two', aon_craft_utils.removeHTMLTags( $( '.key_block #marketing_q_two' ).val() ) );
                    
                $( '.marketing .positive-impact p' ).text( $( '.key_block #marketing_q_one' ).val() );
                $( '.marketing .challenges-faced p' ).text( $( '.key_block #marketing_q_two' ).val() );
                
            } else if ( $( this ).hasClass( 'questions_employees_next' ) ) {
                saveSMQEntry( 'employees_q_one', aon_craft_utils.removeHTMLTags( $( '.key_block #employees_q_one' ).val() ) );
                saveSMQEntry( 'employees_q_two', aon_craft_utils.removeHTMLTags( $( '.key_block #employees_q_two' ).val() ) );
                saveSMQEntry( 'employees_q_three', aon_craft_utils.removeHTMLTags( $( '.key_block #employees_q_three' ).val() ) );
                
                $( '.employees .positive-impact p' ).html( $( '.key_block #employees_q_one' ).val() + '.<br>' + $( '.key_block #employees_q_two' ).val() );
                $( '.employees .challenges-faced p' ).text( $( '.key_block #employees_q_three' ).val() );
                
            } else if ( $( this ).hasClass( 'questions_documentation_next' ) ) {
                saveSMQEntry( 'documentation_q_one', aon_craft_utils.removeHTMLTags( $( '.key_block #documentation_q_one' ).val() ) );
                saveSMQEntry( 'documentation_q_two', aon_craft_utils.removeHTMLTags( $( '.key_block #documentation_q_two' ).val() ) );
                saveSMQEntry( 'documentation_q_three', aon_craft_utils.removeHTMLTags( $( '.key_block #documentation_q_three' ).val() ) );
                
                $( '.documentation .positive-impact p' ).html( $( '.key_block #documentation_q_one' ).val() + '.<br>' + $( '.key_block #documentation_q_two' ).val() );
                $( '.documentation .challenges-faced p' ).text( $( '.key_block #documentation_q_three' ).val() );
            }
            
            callCheckEarnedBadges();
            
            event.preventDefault();
        });
        
        var saveSMQEntry = ( targ, content ) => {
            //console.log( 'saveSMQEntry - start ' );
            this.aon_section_5c_data[ 0 ][ targ ] = content;
            console.table( this.aon_section_5c_data ); 
        }
        
                
        
        // SUSTAINABILITY LABEL MODALS...
        $( 'body' ).on( 'click', '#sustainability_label_modal_1 .button', ( event ) => {
            $( '#sustainability_label_modal_1' ).addClass( 'hide' );
            $( '#sustainability_label_modal_2' ).removeClass( 'hide' );
            $( '#sustainability_label_modal_3' ).addClass( 'hide' );
            // Render Purpose Statement text into field...
            $( '.sustainability-label-content .sustainability-purpose-statement h4' ).text( this.aon_section_5a_data[ 0 ][ 'business_purpose_statement' ] );
            //
            event.preventDefault();
        });
        
        $( 'body' ).on( 'click', '#sustainability_label_modal_2 .button', ( event ) => {
            $( '#sustainability_label_modal_1' ).addClass( 'hide' );
            $( '#sustainability_label_modal_2' ).addClass( 'hide' );
            $( '#sustainability_label_modal_3' ).removeClass( 'hide' );
            // Show Purpose Statement Badges...
            this.setBadges( 'purpose_statement' );
            event.preventDefault();
        });
        
        $( 'body' ).on( 'click', '#sustainability_label_modal_3 .button', ( event ) => {
            $( '#sustainability_label_modal_1' ).addClass( 'hide' );
            $( '#sustainability_label_modal_2' ).addClass( 'hide' );
            $( '#sustainability_label_modal_3' ).addClass( 'hide' );
            // Show Previous Excercise Badges...
            // Statement and Badges shown now so enable `Next` button
            $( '.set_statement_badges_next' ).removeClass( 'disabled' );
            
            this.setBadges( 'set_badges_earned_5c_label' );
            
            event.preventDefault();
        });
        
        // Click on 'save_data' to submit completed data to backend storage...
        $( 'body' ).on( 'click', '.save_data', ( event ) => {
            this.saveData();
        });
        
        // Drag / Resize Map Diagrams
        var dragItem;
        var container;
        var active = false;
        var currentX;
        var currentY;
        var initialX;
        var initialY;
        var xOffset;
        var yOffset;
        var scale;
        function setDragItemAndContainer( mode ) {
            currentX = 0;
            currentY = 0;
            xOffset = 0;
            yOffset = 0;
            scale = 1;
            console.log( 'setDragItem: ' + mode );
            if ( mode == 'sustainability_map_static' ) {
                dragItem = document.querySelector( '#sustainability_map_static:not(.disabled)' );
                container = document.querySelector( '#sustainability_map_static_container' );
            } else if ( mode == 'sustainability_map_generated' ) {
                dragItem = document.querySelector( '#sustainability_map_generated:not(.disabled)' );
                container = document.querySelector( '#sustainability_map_generated_container' );
            }

            container.addEventListener("touchstart", dragStart, false);
            container.addEventListener("touchend", dragEnd, false);
            container.addEventListener("touchmove", drag, false);

            container.addEventListener("mousedown", dragStart, false);
            container.addEventListener("mouseup", dragEnd, false);
            container.addEventListener("mouseleave", dragEnd, false);
            container.addEventListener("mousemove", drag, false);
        }
        //setDragItemAndContainer( 'sustainability_map_static' );
        
        function dragStart(e) {
            console.log( 'dragStart' );
            if (e.type === "touchstart") {
                console.log( 'touchstart' );
                initialX = e.touches[0].clientX - xOffset;
                initialY = e.touches[0].clientY - yOffset;
            } else {
                initialX = e.clientX - xOffset;
                initialY = e.clientY - yOffset;
            }

            console.log( 'e.target.getAttribute( \'id\' ): ' + e.target.getAttribute( 'id' ) );
            console.log( 'e.target.offsetWidth: ' + e.target.offsetWidth );
            console.log( 'e.target.scrollWidth: ' + e.target.scrollWidth );
            if (e.target === dragItem) {
                active = true;
            }
        }

        function dragEnd(e) {
            console.log( 'dragEnd' );
            initialX = currentX;
            initialY = currentY;
            $( '#sustainability_map_static' ).removeClass( 'dragging' );
            $( '#sustainability_map_generated' ).removeClass( 'dragging' );
            active = false;
        }

        function drag(e) {
            console.log( 'drag' );
            if (active) {
                console.log( 'drag - active' );
                e.preventDefault();

                $( '#sustainability_map_static' ).addClass( 'dragging' );
                $( '#sustainability_map_generated' ).addClass( 'dragging' );
                
                if ( e.type === 'touchmove' ) {
                    currentX = e.touches[0].clientX - initialX;
                    currentY = e.touches[0].clientY - initialY;
                } else {
                    currentX = e.clientX - initialX;
                    currentY = e.clientY - initialY;
                }

                xOffset = currentX;
                yOffset = currentY;

                setTranslate(currentX, currentY, scale, dragItem);
            } else {
                console.log( 'drag - NOT active' );
                $( '#sustainability_map_static' ).removeClass( 'dragging' );
                $( '#sustainability_map_generated' ).removeClass( 'dragging' );
            }
        }

        function setTranslate(xPos, yPos, scale, el) {
            console.log( 'setTranslate' );
            el.style.transform = "perspective(1px) translate3d(" + xPos + "px, " + yPos + "px, 0) scale(" + scale + ")";
        }
        
        // Change Scale
        $( 'body' ).on( 'moved.zf.slider', '#sustainability_map_static_zoom_controls', ( event ) => {
            scale = Number( $( '#sustainability_map_static_zoom_controls .zoom-value' ).val() );
            console.log( 'Scale translate call: ' + dragItem.getAttribute( 'id' ) );
            console.log( 'Scale translate currentX: ' + currentX );
            console.log( 'Scale translate currentY: ' + currentY );
            setTranslate(currentX, currentY, scale, dragItem);
        });  
        
        $( 'body' ).on( 'moved.zf.slider', '#sustainability_map_generated_zoom_controls', ( event ) => {
            scale = Number( $( '#sustainability_map_generated_zoom_controls .zoom-value' ).val() );
            console.log( 'Scale translate call: ' + dragItem.getAttribute( 'id' ) );
            console.log( 'Scale translate currentX: ' + currentX );
            console.log( 'Scale translate currentY: ' + currentY );
            setTranslate(currentX, currentY, scale, dragItem);
        });  
        
        // Activate Map slider
        $( 'body' ).on( 'click', '.activate_generated_map', ( event ) => {
            setDragItemAndContainer( 'sustainability_map_generated' );
            event.preventDefault();
        });

        $( 'body' ).on( 'click', '.activate_static_map', ( event ) => {
            setDragItemAndContainer( 'sustainability_map_static' );
            event.preventDefault();
        });
        
        // Trigger generated map if on `Business Plan` page
        if ( $( '#business_plan #sustainability_map_generated' ).length > 0 ) {
            setDragItemAndContainer( 'sustainability_map_generated' );
        }
        

    },
    
    setBadges( mode ) { // SET ACTIVE BADGES

        // Set Purpose Statement Badges...
        if ( mode == 'purpose_statement' ) {
            var issue_badge_id = this.aon_section_5a_data[0].selected_task_impact_issue_items.issue_badge_id;
            var impact_badge_id = this.aon_section_5a_data[0].selected_task_impact_issue_items.impact_badge_id;
            console.log( 'issue_badge_id: ' + issue_badge_id );
            console.log( 'impact_badge_id: ' + impact_badge_id );
            if ( issue_badge_id != '' ) {
                var badge_target_content = $( '.sustainability-badges-container-source .sustainability-badge[data-badge-id="' + issue_badge_id + '"]' ).html();
                $( '.sustainability-label-badges-container.purpose-statement-badges .sustainability-badge-issue' ).html( badge_target_content ).addClass( 'active' );
            } else {
                $( '.sustainability-label-badges-container.purpose-statement-badges .sustainability-badge-issue' ).html( '' );
            }
            if ( impact_badge_id != '' ) {
                var badge_target_content = $( '.sustainability-badges-container-source .sustainability-badge[data-badge-id="' + impact_badge_id + '"]' ).html();
                $( '.sustainability-label-badges-container.purpose-statement-badges .sustainability-badge-impact' ).html( badge_target_content ).addClass( 'active' );
            } else {
                $( '.sustainability-label-badges-container.purpose-statement-badges .sustainability-badge-impact' ).html( '' );
            }
        }

        // Set earned Badges for 5c on main badges screen...
        if ( mode == 'set_badges_earned_5c_main' ) {
            // Get all the badges earned from the questions in this excercise and add to the initial main badges screen
            //badges_earned_count
            // Clear badges markup...
            $( '#badges_earned' ).html( '' );
            // Loop over `badges_earned_array` and add badges...
            var badge_item_markup = '';
            $.each( this.badges_earned_array, function( index, value ) {
                var badge_target_content = $( '.sustainability-badges-container-source .sustainability-badge[data-badge-id="' + value + '"]' ).html();
                badge_item_markup += '<div class="columns small-3 medium-3 large-3 text-center sustainability-badge active" data-active-badge-id="' + value + '">' + badge_target_content + '</div>';
            });
            $( '#badges_earned' ).html( badge_item_markup );
            $( '.badges_earned_count' ).text( this.badges_earned_array.length );
            // If Zero badges are earned then we hide the `Congratulations! You earned X of 7 Sustainability Badges` message and show an alternative instead:
            console.log( 'this.badges_earned_array.length: ' + this.badges_earned_array.length );
            if ( this.badges_earned_array.length == 0 ) {
                $( '.zero_badges_earned_heading' ).removeClass( 'hide' );
                $( '.zero_badges_earned_image' ).removeClass( 'hide' );
                $( '.badges_earned_heading' ).addClass( 'hide' );
                $( '.badges_earned_message' ).addClass( 'hide' );
                $( '.badges_earned_column' ).addClass( 'hide' );
            } else {
                $( '.zero_badges_earned_heading' ).addClass( 'hide' );
                $( '.zero_badges_earned_image' ).addClass( 'hide' );
                $( '.badges_earned_heading' ).removeClass( 'hide' );
                $( '.badges_earned_message' ).removeClass( 'hide' );
                $( '.badges_earned_column' ).removeClass( 'hide' );
            }

        }

        // Set earned Badges for 5c on Label screen...
        if ( mode == 'set_badges_earned_5c_label' ) {
            // Get all the badges earned from the questions in this excercise and add to the Label badges screen
            $( '#badges_earned_label' ).html( '' );
            // Loop over `badges_earned_array` and add badges...
            var badge_item_markup = '';
            $.each( this.badges_earned_array, function( index, value ) {
                var badge_target_content = $( '.sustainability-badges-container-source .sustainability-badge[data-badge-id="' + value + '"]' ).html();
                badge_item_markup += '<div class="columns small-5 medium-5 large-5 text-center sustainability-badge active" data-active-badge-id="' + value + '">' + badge_target_content + '</div>';
            });
            $( '#badges_earned_label' ).html( badge_item_markup );
        }

    },
    
    addToBadgesEarnedArray( badge_id ) {
        // Add to `badges_earned_array` but check if ID already exists in it, if not then add...
        if ( jQuery.inArray( badge_id, this.badges_earned_array ) == -1 ) {
            this.badges_earned_array.push( badge_id );
        }
        console.log( 'this.badges_earned_array' );
        console.table( this.badges_earned_array )
    },
    
    removeFromBadgesEarnedArray( badge_id ) {
        // Remove from `badges_earned_array` if it exists...
        console.log( 'Remove from `badges_earned_array` if it exists...' );
        console.log( 'Is in array? ' + jQuery.inArray( badge_id, this.badges_earned_array ) );
        console.table( this.badges_earned_array );
        if ( jQuery.inArray( badge_id, this.badges_earned_array ) != -1 ) {
            this.badges_earned_array.splice( jQuery.inArray( badge_id, this.badges_earned_array ), 1 );
            console.log( 'Removed "' + jQuery.inArray( badge_id, this.badges_earned_array ) + '" from `this.badges_earned_array`' );
        }
        console.log( 'this.badges_earned_array' );
        console.table( this.badges_earned_array );
    },
    
    checkEarnedBadges() {
        
        /*// Add to `badges_earned_array` but check if ID already exists in it, if not then add...
        var addToBadgesEarnedArray = ( badge_id ) => {
            if ( jQuery.inArray( badge_id, this.badges_earned_array ) == -1 ) {
                this.badges_earned_array.push( badge_id );
            }
            console.log( 'this.badges_earned_array' );
            console.table( this.badges_earned_array );
        }*/
        
        // Set 12 - Recycle and reuse
        // Designing
        // Developing
        // Sourcing materials
        // Documentation
        if ( 
            $( '#designing_q_one' ).val() != '' ||
            $( '#developing_q_one' ).val() != '' ||
            $( '#sourcing_q_three' ).val() != '' ||
            $( '#documentation_q_two' ).val() != ''
           ) {
            this.addToBadgesEarnedArray( 12 );
            
        } else if ( 
            $( '#designing_q_one' ).val() == '' &
            $( '#developing_q_one' ).val() == '' &
            $( '#sourcing_q_three' ).val() == '' &
            $( '#documentation_q_two' ).val() == ''
           ) {
            this.removeFromBadgesEarnedArray( 12 );
        }
      
        // Set 13 - Minimise petrol or wood burning
        // Sourcing materials
        // Distribution
        if ( 
            $( '#sourcing_q_one' ).val() != '' ||
            $( '#distribution_q_one' ).val() != ''
           ) {
            this.addToBadgesEarnedArray( 13 );
            
        } else if ( 
            $( '#sourcing_q_one' ).val() == '' &
            $( '#distribution_q_one' ).val() == ''
           ) {
            this.removeFromBadgesEarnedArray( 13 );
        }

        // Set 15 - Work in harmony with nature
        // Sourcing materials
        if ( 
            $( '#sourcing_q_two' ).val() != ''
           ) {
            this.addToBadgesEarnedArray( 15 );
            
        } else if ( 
            $( '#sourcing_q_two' ).val() == ''
           ) {
            this.removeFromBadgesEarnedArray( 15 );
        }
        
        // Set 8 - Provide work that is valued
        // Transforming materials
        // Distribution
        if ( 
            $( '#transforming_q_one' ).val() != '' ||
            $( '#distribution_q_two' ).val() != ''
           ) {
            this.addToBadgesEarnedArray( 8 );
            
        } else if ( 
            $( '#transforming_q_one' ).val() == '' &
            $( '#distribution_q_two' ).val() == ''
           ) {
            this.removeFromBadgesEarnedArray( 8 );
        }
        
        // Set 1 - Ensure financial wellbeing
        // Employees
        if ( 
            $( '#employees_q_one' ).val() != ''
           ) {
            this.addToBadgesEarnedArray( 1 );
            
        } else if ( 
            $( '#employees_q_one' ).val() == ''
           ) {
            this.removeFromBadgesEarnedArray( 1 );
        }

        // Set 3 - Promote health and wellbeing at work
        // Employees
        if ( 
            $( '#employees_q_two' ).val() != ''
           ) {
            this.addToBadgesEarnedArray( 3 );
            
        } else if ( 
            $( '#employees_q_two' ).val() == ''
           ) {
            this.removeFromBadgesEarnedArray( 3 );
        }

        // Set 7 - Use clean or renewable energy
        // Documentation
        if ( 
            $( '#documentation_q_one' ).val() != ''
           ) {
            this.addToBadgesEarnedArray( 7 );
            
        } else if ( 
            $( '#documentation_q_one' ).val() == ''
           ) {
            this.removeFromBadgesEarnedArray( 7 );
        }
        
        // Set badges earned
        this.setBadges( 'set_badges_earned_5c_main' );
        
        // Save badges earned to data array
        this.aon_section_5c_data[ 0 ][ 'badges_earned' ] = this.badges_earned_array;
        
    },
    
    loadDataFrom5a() {
        // Load from json array in page
        var aon_section_5a_data_json = $( '#section_5a_data_json' ).val();
        this.aon_section_5a_data = JSON.parse( aon_section_5a_data_json );
    },
    
    renderData() {
        console.log( 'renderData - Section 5C');
        
        // Get saved data from 5A...
        this.loadDataFrom5a();
        
        $.each( this.aon_section_5c_data, function( index ) {
            // Loop over data entries...   
            // Begin Text field entries...           
            $( '.key_block #designing_q_one' ).val( this.designing_q_one );
            $( '.key_block #designing_q_two' ).val( this.designing_q_two );
            
            $( '.key_block #developing_q_one' ).val( this.developing_q_one );
            $( '.key_block #developing_q_two' ).val( this.developing_q_two );
            
            $( '.key_block #sourcing_q_one' ).val( this.sourcing_q_one );
            $( '.key_block #sourcing_q_two' ).val( this.sourcing_q_two );
            $( '.key_block #sourcing_q_three' ).val( this.sourcing_q_three );
            $( '.key_block #sourcing_q_four' ).val( this.sourcing_q_four );
            
            $( '.key_block #transforming_q_one' ).val( this.transforming_q_one );
            $( '.key_block #transforming_q_two' ).val( this.transforming_q_two );

            $( '.key_block #packaging_q_one' ).val( this.packaging_q_one );
            $( '.key_block #packaging_q_two' ).val( this.packaging_q_two );

            $( '.key_block #distribution_q_one' ).val( this.distribution_q_one );
            $( '.key_block #distribution_q_two' ).val( this.distribution_q_two );
            $( '.key_block #distribution_q_three' ).val( this.distribution_q_three );

            $( '.key_block #marketing_q_one' ).val( this.marketing_q_one );
            $( '.key_block #marketing_q_two' ).val( this.marketing_q_two );

            $( '.key_block #employees_q_one' ).val( this.employees_q_one );
            $( '.key_block #employees_q_two' ).val( this.employees_q_two );
            $( '.key_block #employees_q_three' ).val( this.employees_q_three );

            $( '.key_block #documentation_q_one' ).val( this.documentation_q_one );
            $( '.key_block #documentation_q_two' ).val( this.documentation_q_two );
            $( '.key_block #documentation_q_three' ).val( this.documentation_q_three );
            
        });
    },
    
    addDataEntry() {
        console.log( 'addDataEntry - start' );
        // Default variables for data structure...
        var designing_q_one = '';
        var designing_q_two = '';

        var developing_q_one = '';
        var developing_q_two = '';

        var sourcing_q_one = '';
        var sourcing_q_two = '';
        var sourcing_q_three = '';
        var sourcing_q_four = '';

        var transforming_q_one = '';
        var transforming_q_two = '';

        var packaging_q_one = '';
        var packaging_q_two = '';

        var distribution_q_one = '';
        var distribution_q_two = '';
        var distribution_q_three = '';

        var marketing_q_one = '';
        var marketing_q_two = '';

        var employees_q_one = '';
        var employees_q_two = '';
        var employees_q_three = '';

        var documentation_q_one = '';
        var documentation_q_two = '';
        var documentation_q_three = '';
        
        var badges_earned = [];
        
        // Push default data to data structure array...
        this.aon_section_5c_data.push( { 
            designing_q_one,
            designing_q_two,
            developing_q_one,
            developing_q_two,
            sourcing_q_one,
            sourcing_q_two,
            sourcing_q_three,
            sourcing_q_four,
            transforming_q_one,
            transforming_q_two,
            packaging_q_one,
            packaging_q_two,
            distribution_q_one,
            distribution_q_two,
            distribution_q_three,
            marketing_q_one,
            marketing_q_two,
            employees_q_one,
            employees_q_two,
            employees_q_three,
            documentation_q_one,
            documentation_q_two,
            documentation_q_three,
            badges_earned 
        } );
        
        
        console.log( 'addDataEntry: '  );
        console.table( this.aon_section_5c_data );
    },
    
    loadData( mode ) {
        /*
         * Set Data.
         * Either load existing data from backend or set default blank data...
         */
        
        // Load data from backend...
        if ( mode == 'load_live' ) {
            // Load from json array in page
            var aon_section_5c_data_json = $( '#section_5c_data_json' ).val();
            this.aon_section_5c_data = JSON.parse( aon_section_5c_data_json );
            console.table( this.aon_section_5c_data );
            
            var callAddToBadgesEarnedArray = ( badge_id ) => {
                this.addToBadgesEarnedArray( badge_id );
            }
            // Assign any saved earned badges data to `this.badges_earned_array`
            $.each( this.aon_section_5c_data[ 0 ][ 'badges_earned' ], function( index, value ) {
                callAddToBadgesEarnedArray( value );
            });
            // Set badges earned
            this.setBadges( 'set_badges_earned_5c_main' );

            // Save badges earned to data array
            this.aon_section_5c_data[ 0 ][ 'badges_earned' ] = this.badges_earned_array;
            
            
        } else if ( mode == 'load_demo' ) {
            // Using temp JSON source for now...
            var aon_section_5c_data_json = '[{';
                aon_section_5c_data_json += '"designing_q_one:"",';
                aon_section_5c_data_json += '"designing_q_two:"",';
                aon_section_5c_data_json += '"developing_q_one:"",';
                aon_section_5c_data_json += '"developing_q_two:"",';
                aon_section_5c_data_json += '"sourcing_q_one:"",';
                aon_section_5c_data_json += '"sourcing_q_two:"",';
                aon_section_5c_data_json += '"sourcing_q_three:"",';
                aon_section_5c_data_json += '"sourcing_q_four:"",';
                aon_section_5c_data_json += '"transforming_q_one:"",';
                aon_section_5c_data_json += '"transforming_q_two:"",';
                aon_section_5c_data_json += '"packaging_q_one:"",';
                aon_section_5c_data_json += '"packaging_q_two:"",';
                aon_section_5c_data_json += '"distribution_q_one:"",';
                aon_section_5c_data_json += '"distribution_q_two:"",';
                aon_section_5c_data_json += '"distribution_q_three:"",';
                aon_section_5c_data_json += '"marketing_q_one:"",';
                aon_section_5c_data_json += '"marketing_q_two:"",';
                aon_section_5c_data_json += '"employees_q_one:"",';
                aon_section_5c_data_json += '"employees_q_two:"",';
                aon_section_5c_data_json += '"employees_q_three:"",';
                aon_section_5c_data_json += '"documentation_q_one:"",';
                aon_section_5c_data_json += '"documentation_q_two:"",';
                aon_section_5c_data_json += '"documentation_q_three:"",';
                aon_section_5c_data_json += '"badges_earned:[],';
                aon_section_5c_data_json += '}]';

            this.aon_section_5c_data = JSON.parse( aon_section_5c_data_json );
            console.table( this.aon_section_5c_data );
            
        } else if ( mode == 'start' ) {
            this.addDataEntry();
            
        }
      
    },
    
    saveData() {
        // Call AJAX request to WP / Rest API
        // Save completed data to backend...        
        var jsonDataString = JSON.stringify( this.aon_section_5c_data );
        console.log( 'jsonDataString: ' + jsonDataString );
        
        console.log( '5C AJAX - START' );
        var meta = { 'section_5c_data_one' : jsonDataString };
        $.ajax({
            url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
            method: 'POST',
            beforeSend: function ( xhr ) {
                xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
            },
            data: {
                'meta' : meta
            }
        }).done( function ( response ) {
            console.log( 'Response: ' );
            console.log( response );
        });
        console.log( '5C AJAX - END' );
        
        console.log( 'Saving data via AJAX, saving the following:' );
        console.table( this.aon_section_5c_data );
 
    }

}